import { ca } from '@cian/analytics';

export function trackSellersCarouselAllOffersClick(agentId: number): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'media_agent_banner_carousel_to_listing',
    page: {
      extra: {
        agentId,
      },
    },
  });
}
